export const HOME_FAQ_ITEMS = [
  {
    question: 'How often should I visit the dentist?',
    answer:
      'Regular dental checkups are recommended every 6 months to maintain good oral health and catch issues early.',
  },
  {
    question: 'Do you offer teeth whitening treatments?',
    answer:
      'Yes, we provide professional teeth whitening treatments to help improve the appearance of your smile.',
  },
  {
    question: 'Is root canal treatment painful?',
    answer:
      'Modern root canal treatment is generally comfortable and helps relieve tooth pain caused by infection.',
  },
  {
    question: 'Do I need an appointment before visiting?',
    answer:
      'Appointments are recommended to reduce waiting time, but walk-in patients are also welcome.',
  },
  {
    question: 'What dental services do you provide?',
    answer:
      'We offer general dentistry, teeth whitening, root canal treatment, dental implants, braces, scaling, and other dental care services.',
  },
] as const;

export const HOME_FEATURED_ARTICLE_SLUGS = [
  'teeth-whitening-in-nepal-professional-treatment-vs-home-remedies-which-works-better',
  'root-canal-treatment-in-nepal',
  'complete-dental-care-in-lalitpur-from-checkups-to-advanced-treatments',
] as const;

export const PRIMARY_INTERNAL_LINKS = [
  { href: '/services/', label: 'Services' },
  { href: '/appointments/', label: 'Appointments' },
  { href: '/articles/', label: 'Articles' },
  { href: '/gallery/', label: 'Gallery' },
  { href: '/about/', label: 'About Us' },
  { href: '/contact/', label: 'Contact Us' },
] as const;

export const AUTHORITY_LINKS = [
  {
    label: 'Nepal Dental Association',
    href: 'https://www.nda.org.np/',
  },
  {
    label: 'Ministry of Health Nepal',
    href: 'https://mohp.gov.np/',
  },
] as const;
